export default "__VITE_ASSET__DaDYYFqQ__"